// ignore-string-externalization

import styled from 'styled-components';
import {
  spacer12,
  spacer16,
  spacer20,
  spacer40,
  spacer64,
  cssColorValue,
  ButtonTertiary,
  screenXsMax,
  Type,
} from '@spotify-internal/encore-web';
import {
  MobileResponsiveType,
  ONE_COLUMN_MAX_WIDTH,
  TWO_COLUMN_MAX_WIDTH,
} from '@spotify-internal/frodor-modules';
import { getLinkStyle } from '../../ui';

export const OpenSideMenuButton = styled(ButtonTertiary)`
  vertical-align: top;
  color: ${cssColorValue('textBase')};
  &:hover {
    cursor: pointer;
  }
`;

export const CloseSideMenuButton = styled(ButtonTertiary)`
  position: absolute;
  color: ${cssColorValue('textBase')};
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1200px) {
    top: ${spacer16};
    right: 40px;
  }

  @media (max-width: ${screenXsMax}) {
    top: ${spacer16};
    right: 16px;
  }
`;

export const SideMenuLink = styled(MobileResponsiveType).attrs({
  variantTablet: 'canon',
  variantPhone: 'cello',
  weight: 'bold',
})``;

export const SideMenuAction = styled(MobileResponsiveType).attrs({
  variantTablet: 'canon',
  variantPhone: 'cello',
  weight: 'book',
})``;

export const SidemenuSeparator = styled.div`
  width: ${spacer40};
  height: 0;
  border-top: 1px solid ${cssColorValue('decorativeSubdued')};
  /* in addtion to li spacing: */
  margin-top: ${spacer12};
  margin-bottom: ${spacer12};
`;

export const SideMenuCategory = styled(MobileResponsiveType).attrs({
  variantTablet: 'canon',
  variantPhone: 'cello',
  weight: 'bold',
})``;

export const SideMenuCategoryTitle = styled(MobileResponsiveType).attrs({
  variantTablet: 'canon',
  variantPhone: 'cello',
  weight: 'bold',
})<{ down: boolean }>`
  cursor: pointer;
  svg {
    margin-left: ${spacer12};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      vertical-align: ${({ down }) => (down ? '-7px' : '-3px')};
    }
    @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
      vertical-align: ${({ down }) => (down ? '-10px' : '-7px')};
    }
  }
`;

export const SideMenuCategoryItem = styled(Type).attrs({
  variant: 'ballad',
})`
  a,
  button {
    svg {
      fill: #8f8f8f !important;
    }
    color: #8f8f8f !important;
  }

  [dir='rtl'] & * {
    direction: rtl;
    & > svg {
      transform: rotateY(180deg);
    }
  }
  svg {
    vertical-align: -3px;
  }
`;

export const StyledSideMenu = styled.nav`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 320px;
  padding: ${spacer64} ${spacer20} ${spacer20} ${spacer20};
  background: ${props => props.theme.nav.sideMenuBackground};
  z-index: 1041; /* over the backdrop */
  overflow: auto;
  :focus {
    outline: none !important;
  }

  display: flex;
  flex-direction: column;
  &,
  a,
  a:visited,
  button span,
  button svg {
    color: ${props => props.theme.nav.sideMenuTextColor};
  }

  ${SideMenuCategory} {
    a,
    button {
      ${(props: any) => getLinkStyle(props)}
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    flex: 1;
    li {
      width: 100%;
      margin-bottom: ${spacer20};

      /* sub menu */
      ul {
        margin-top: ${spacer20};
        padding-bottom: 0;
        li {
          margin-left: ${spacer20};
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  ul,
  ol {
    list-style: none;
    padding-left: 0;
  }
`;
